import { render, staticRenderFns } from "./newCwvDomainCard.vue?vue&type=template&id=39323218"
import script from "./newCwvDomainCard.vue?vue&type=script&lang=ts"
export * from "./newCwvDomainCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports